import { memo } from 'react';
import { selectTaskById, useKanbanEventStore } from '../store';
import { KanbanBatch } from './KanbanBatch';
import { KanbanTask } from './KanbanTask';

type KanbanTaskSwitchProps = {
  id: number;
};

export const KanbanTaskResolver = memo(({ id }: KanbanTaskSwitchProps) => {
  const task = useKanbanEventStore(selectTaskById(id));

  switch (task?.tpe) {
    case 'Task':
      return <KanbanTask task={task} />;
    case 'Batch':
      return <KanbanBatch batch={task} />;
    default:
      return null;
  }
});

KanbanTaskResolver.displayName = 'KanbanTaskSwitch';
